import { render, staticRenderFns } from "./BatchProductionLoggerList.vue?vue&type=template&id=9f5d690e&scoped=true"
import script from "./BatchProductionLoggerList.vue?vue&type=script&lang=js"
export * from "./BatchProductionLoggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d690e",
  null
  
)

export default component.exports